// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1022":"49073288","6706":"214f15b8","9507":"da2bf6c4"}[chunkId] || chunkId) + "." + {"1022":"349efd3425b8fc9c","1386":"6841e18b88c54be3","6361":"f79563a35c9cd322","6706":"73301a60bc48cf77","9507":"610e2a24f29a6592"}[chunkId] + ".js";
};